import useSearchFilter from "hooks/useSearchFilter"
import PropTypes from "prop-types"
import React from "react"
import moment from "moment"
import Month from "./Views/Month"
import Week from "./Views/Week"
import Day from "./Views/Day"

const getCalendarComponent = () => {
  return { month: Month, week: Week, date: Day }
}

const CalendarViewSwitcher = ({ onChangeFilters, experienceIds, crewIds, equipmentIds, categoryIds, roleIds }) => {
  const [params] = useSearchFilter({ accessAttributes: ["range", "date", "agenda", "tab"] })

  // Use today for month view if date is start of month
  const calendarDate = params.range === "month" && params.date === moment().startOf("month").format("YYYY-MM-DD")
    ? moment().format("YYYY-MM-DD")
    : params.date;

  if (!calendarDate || !params.range) return null
  const Calendar = getCalendarComponent()[params.range]

  return (
    <Calendar
      date={calendarDate}
      onChangeFilters={onChangeFilters}
      activeTab={params.tab}
      experienceIds={experienceIds}
      crewIds={crewIds}
      equipmentIds={equipmentIds}
      categoryIds={categoryIds}
      roleIds={roleIds}
    />
  )
}

CalendarViewSwitcher.propTypes = {
  onChangeFilters: PropTypes.func.isRequired,
  experienceIds: PropTypes.array,
  crewIds: PropTypes.array,
  equipmentIds: PropTypes.array,
  categoryIds: PropTypes.array,
  roleIds: PropTypes.array,
}

export default CalendarViewSwitcher
